module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ApplyView.js"));
	}, "MaterialApplyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MaterialApplyView!./src/pages/Promote/BusinessHall/AlterMaterial/Apply/ApplyView.js
// module id = 2080
// module chunks = 367